module.exports = __webpack_public_path__ + "img/credential-text-niice.f5e1d94251aa101c7ca0d9266e169739.svg";